import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "sidebar"]

  toggle() {
    const isOpen = !this.overlayTarget.classList.contains("hidden")

    if (isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    // Show overlay
    this.overlayTarget.classList.remove("hidden")

    // Slide in sidebar
    this.sidebarTarget.classList.remove("-translate-x-full")

    // Prevent body scroll
    document.body.style.overflow = "hidden"
  }

  close() {
    // Hide overlay
    this.overlayTarget.classList.add("hidden")

    // Slide out sidebar
    this.sidebarTarget.classList.add("-translate-x-full")

    // Restore body scroll
    document.body.style.overflow = ""
  }

  // Close menu when window is resized to desktop size
  connect() {
    this.handleResize = this.handleResize.bind(this)
    window.addEventListener("resize", this.handleResize)
  }

  disconnect() {
    window.removeEventListener("resize", this.handleResize)
  }

  handleResize() {
    if (window.innerWidth >= 1024) { // lg breakpoint
      this.close()
    }
  }
}
